import React from "react";
import * as Const from "./../_Const";
import useDarkMode from "../hooks/useDarkMode";
import useCssProperty from "../hooks/useCssProperty";
import useScreenType from "../hooks/useScreenType";

const Splash = () => {
  const screenType = useScreenType();
  const colorAccent = useCssProperty("--color-accent");
  const colorAccentDark = useCssProperty("--color-accent-dark");
  const [isDarkMode] = useDarkMode();
  const isVk = Const.isVk();
  const fill = isDarkMode ? colorAccent : colorAccentDark;
  // if(isVk){
  //   fill =
  // }
  let image = isDarkMode ? "/img/logo_cekarnavmobilu_dark.png" : "/img/logo_cekarnavmobilu.png";
  if (isVk) {
    image = "/img/logo_vk_big.png";
  }

  let title = Const.isTerminal() ? "Registrace online pomocí mobilního telefonu a tabletu" : "Registrace online pomocí mobilního telefonu";
  if (isVk) {
    title = "Pořadový systém do čekárny";
  }

  const version = process.env.REACT_APP_VERSION;

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "title":
          css = "text-4xl mt-8";
          break;
        case "image":
          css = "h-[200px]";
          break;
        case "version":
          css = "bottom-4 text-base";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "title":
          css = "text-6xl mt-16";
          break;
        case "image":
          css = "h-[250px]";
          break;
        case "version":
          css = "bottom-8 text-xl";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "title":
          css = "text-6xl mt-16";
          break;
        case "image":
          css = "h-[280px]";
          break;
        case "version":
          css = "bottom-8 text-xl";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "title":
          css = "text-6xl mt-16";
          break;
        case "image":
          css = "h-[280px]";
          break;
        case "version":
          css = "bottom-8 text-xl";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }
  return (
    <>
      {isVk && (
        <>
          <div className={`${getCssFor("title")} text-center text-accent-dark dark:text-accent font-black`}>{title}</div>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <img src={image} className={`${getCssFor("image")} `} />
          </div>
          <div className={`${getCssFor("version")} absolute text-center text-primary  w-full`}>Verze: {version}</div>
        </>
      )}

      {!isVk && (
        <>
          <div className="text-accent-dark dark:text-accent font-black text-[42px] mb-10">Vítejte v čekárně</div>
          <div className="flex justify-center items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="184" height="328.485" viewBox="0 0 184 328.485">
              <g id="Group_23" data-name="Group 23" transform="translate(-114 -282)">
                <path
                  id="Icon_ionic-ios-phone-portrait"
                  data-name="Icon ionic-ios-phone-portrait"
                  d="M209.85,11.625H79.514c-15.039,0-27.2,10.705-27.2,24.123V315.107c0,13.491,12.163,25,27.2,25H209.768c15.039,0,26.544-11.512,26.544-25V35.748C236.394,22.33,224.889,11.625,209.85,11.625ZM132.026,28.489H156.68a3.134,3.134,0,0,1,3.287,2.933,3.134,3.134,0,0,1-3.287,2.933H132.026a3.134,3.134,0,0,1-3.287-2.933A3.134,3.134,0,0,1,132.026,28.489Zm12.738,300.622c-7.889,0-14.3-5.719-14.3-12.758s6.41-12.758,14.3-12.758,14.3,5.719,14.3,12.758S152.653,329.111,144.764,329.111ZM221.6,293.183H67.1a1.567,1.567,0,0,1-1.644-1.466V50.486A1.567,1.567,0,0,1,67.1,49.019H221.6a1.567,1.567,0,0,1,1.644,1.466V291.717A1.567,1.567,0,0,1,221.6,293.183Z"
                  transform="translate(61.688 270.375)"
                  fill={fill}
                />
                <path
                  id="Icon_metro-qrcode"
                  data-name="Icon metro-qrcode"
                  d="M38.594,15.024H18.344v20.25h20.25Zm5.063-5.063V40.337H13.282V9.962ZM23.407,20.087H33.532V30.211H23.407Zm65.813-5.063H68.969v20.25h20.25Zm5.063-5.063V40.337H63.907V9.962ZM74.032,20.087H84.157V30.211H74.032ZM38.594,65.649H18.344V85.9h20.25V65.649Zm5.063-5.062V90.962H13.282V60.587ZM23.407,70.711H33.532V80.836H23.407ZM48.719,9.961h5.063v5.062H48.719Zm5.063,5.062h5.062v5.063H53.782Zm-5.062,5.063h5.063v5.063H48.719Zm5.063,5.063h5.062v5.063H53.782Zm-5.062,5.063h5.063v5.063H48.719Zm5.063,5.063h5.062v5.063H53.782Zm-5.062,5.063h5.063V45.4H48.719Zm0,10.125h5.063v5.063H48.719Zm5.063,5.063h5.062v5.063H53.782Zm-5.062,5.063h5.063v5.063H48.719Zm5.063,5.063h5.062v5.062H53.782Zm-5.062,5.062h5.063v5.063H48.719Zm5.063,5.063h5.062v5.063H53.782Zm-5.062,5.063h5.063V85.9H48.719ZM53.782,85.9h5.062v5.062H53.782ZM89.219,50.461h5.063v5.063H89.219Zm-70.875,0h5.063v5.063H18.344ZM23.407,45.4h5.063v5.063H23.407Zm-10.125,0h5.063v5.063H13.282Zm20.25,0h5.063v5.063H33.532Zm5.063,5.063h5.063v5.063H38.594ZM43.657,45.4h5.062v5.063H43.657Zm15.188,5.063h5.063v5.063H58.844ZM63.907,45.4h5.062v5.063H63.907Zm5.062,5.063h5.063v5.063H68.969ZM74.032,45.4h5.063v5.063H74.032Zm5.063,5.063h5.063v5.063H79.094ZM84.157,45.4h5.062v5.063H84.157Zm5.062,15.188h5.063v5.063H89.219Zm-30.375,0h5.063v5.063H58.844Zm5.063-5.062h5.062v5.062H63.907Zm5.062,5.062h5.063v5.063H68.969Zm10.125,0h5.063v5.063H79.094Zm5.063-5.062h5.062v5.062H84.157Zm5.062,15.187h5.063v5.063H89.219Zm-30.375,0h5.062v5.063H58.844Zm5.062-5.062h5.062v5.062H63.907Zm10.125,0h5.063v5.062H74.032Zm5.063,5.062h5.062v5.063H79.094Zm5.062-5.062h5.063v5.062H84.157Zm5.063,15.188h5.063V85.9H89.219ZM63.907,75.774h5.062v5.063H63.907Zm5.062,5.063h5.063V85.9H68.969Zm5.063-5.062h5.063v5.063H74.032Zm5.063,5.063h5.062V85.9H79.094ZM63.907,85.9h5.062v5.063H63.907Zm10.125,0h5.062v5.063H74.032Zm10.125,0h5.063v5.063H84.157Z"
                  transform="translate(152.63 339.039)"
                  fill={fill}
                />
                <g id="Group_22" data-name="Group 22" transform="translate(-9)">
                  <text id="NFC" transform="translate(180 510)" fill={fill} fontSize="20" fontFamily="RobotoCondensed-Bold, Roboto" fontWeight="700">
                    <tspan x="0" y="0">
                      NFC
                    </tspan>
                  </text>
                  <path
                    id="Icon_metro-wifi-connect"
                    data-name="Icon metro-wifi-connect"
                    d="M37.086,70.86a12.717,12.717,0,0,1,9.851,5.063L43.654,79.99a8.478,8.478,0,0,0-6.567-3.375,8.478,8.478,0,0,0-6.567,3.375l-3.284-4.068A12.717,12.717,0,0,1,37.086,70.86ZM20.66,67.778c4.388-5.435,10.221-8.428,16.426-8.428s12.038,2.993,16.426,8.428l-3.285,4.069C46.717,67.5,42.05,65.1,37.086,65.1S27.456,67.5,23.946,71.847l-3.285-4.07ZM49.746,51.006a33.009,33.009,0,0,1,10.337,8.633L56.8,63.708c-5.265-6.522-12.265-10.114-19.711-10.114S22.64,57.186,17.375,63.708l-3.285-4.07a33.011,33.011,0,0,1,10.337-8.632,26.886,26.886,0,0,1,25.319,0Z"
                    transform="translate(298.751 465.414) rotate(90)"
                    fill={fill}
                  />
                  <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(265 462) rotate(90)" fill="none" stroke={fill} strokeWidth="2">
                    <ellipse cx="40.5" cy="49.5" rx="40.5" ry="49.5" stroke="none" />
                    <ellipse cx="40.5" cy="49.5" rx="39.5" ry="48.5" fill="none" />
                  </g>
                </g>
              </g>
            </svg>
          </div>

          <div className="text-accent-dark dark:text-accent text-xl mt-10 font-light">{title}</div>

          <div className="mt-10 flex justify-items-center place-content-center">
            <img src={image} width={250} />
          </div>
        </>
      )}
    </>
  );
};

export default Splash;
